import { render } from "./AngledNineGrid.vue?vue&type=template&id=5bb8dff2&scoped=true"
import script from "./AngledNineGrid.vue?vue&type=script&lang=js"
export * from "./AngledNineGrid.vue?vue&type=script&lang=js"

import "./AngledNineGrid.vue?vue&type=style&index=0&id=5bb8dff2&scoped=true&lang=css"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb8dff2"]])

export default __exports__